/**
 * AI 입시분석 워크스페이스 유도 배너 — 카피·이미지 SSoT.
 *
 * 커머스에서 세 지점이 같은 카피를 쓴다: 히어로 캐러셀 슬라이드(`AiWorkspaceSlide`, 이미지 포함)·
 * 랜딩 중간 고정 섹션(`AiWorkspaceSection`, 카피 띠만)·모바일 메뉴 카드(`NavAiPromo`). 캐러셀은 자동순환이라
 * 체류 노출이 짧고 인지용이고, 고정 섹션이 100% 노출을 보장한다 — 문구가 어긋나지 않도록 여기서만 관리한다.
 * `image` 는 슬라이드 전용이다.
 *
 * 카피 원칙: 설득은 착지 페이지(워크스페이스 히어로)가 맡고 여기는 티저 — 아이브로·헤드라인·CTA 만.
 * 헤드라인은 워크스페이스 히어로(`LandingHero`)와 같은 문장이라 넘어가도 낯설지 않다.
 * "예측·보장·합격률" 금지(FO 용어집) — "가능성·확인·분석"으로만 쓴다.
 *
 * 데스크톱 판은 **자기설명 인포그래픽**(리포트 + 내 정보 → AI → 분석 리포트, 문구가 그림 안에 구워져 있음)이라
 * 카피 여백이 없다. 그래서 히어로 슬라이드(≥768)는 헤드라인을 얹지 않고 CTA 만 두며, 헤드라인은 높이 제약이
 * 없는 고정 섹션(이미지 위 카피 띠)에서만 쓴다 — 그림을 가려 가며 문구를 넣지 않는다.
 */
export const AI_WORKSPACE_BANNER = {
  eyebrow: 'AI 입시분석 워크스페이스',
  /** 2줄 고정 — `<br>` 대신 배열로 두고 렌더 측이 줄바꿈을 소유한다. */
  headline: ['내가 갈 수 있는 대학,', '데이터로 먼저 확인하세요'] as const,
  cta: 'AI 분석 시작하기',
  alt: 'AI 입시분석 워크스페이스 — 대학별 입시 리포트에 재학 중인 고등학교·내신/수능 성적·희망 대학/학과를 더하면 AI 가 지원 가능 대학 분석 리포트를 만들어 주는 흐름을 그린 그림',
  image: {
    /**
     * 1920×776(≈2.47:1, 히어로 스테이지 1440×580 과 같은 비율) — 카피 여백 없음.
     * 좌 리포트 책 · 입력 카드 3종 → 학생 → AI · 우 분석 리포트 화면. 문구는 그림 안에 있다.
     */
    desktop: '/assets/hero/slide-ai.webp',
    /**
     * 750×801 — 세로 셀 전제의 별개 구도(캐릭터 우하단·UI 카드 좌상단), 텍스트 여백 없음(카피는 이미지 밖 텍스트로).
     * 데스크톱 인포그래픽을 세로 셀에 cover 하면 학생만 남고(폭 29% 창), 3:2 크롭이면 카피 위에 큰 여백이 남는다 —
     * 검토 후 모바일은 이 판을 유지하기로 했다(서사는 카피가 맡는다). 세로 재생성은 모바일 전환 지표가 약할 때 검토.
     */
    mobile: '/assets/hero/slide-ai-m.webp',
  },
} as const;
